import i18n from "@/i18n";
/**
 * VuosilomaHistory — VUOSILOMA-V1. Append-only ledger history with
 * revision state; manager-recorded opening facts can be corrected.
 */
import { Button } from "@/components/ui/button";
import { formatYMDDate } from "./workforceHelpers";
import { vlEntryLabel } from "./vuosilomaHelpers";

const STATE_LABEL = {
    get EFFECTIVE() { return i18n.t("wf.VuosilomaHistory.STATE_LABEL.EFFECTIVE", "Effective"); },
    get REVERSED() { return i18n.t("wf.VuosilomaHistory.STATE_LABEL.REVERSED", "Superseded"); },
    get SUSPENDED() { return i18n.t("wf.VuosilomaHistory.STATE_LABEL.SUSPENDED", "Suspended (period reopened)"); },
    get CORRECTION() { return i18n.t("wf.VuosilomaHistory.STATE_LABEL.CORRECTION", "Correction"); },
};

export default function VuosilomaHistory({ history, canManage, onCorrect }) {
    if (!history?.length) {
        return <p className="text-sm text-neutral-500" data-testid="vl-history-empty">{i18n.t("wf.vuosilomaHistory.noEntriesYet", "No entries yet.")}</p>;
    }
    return (
        <ul className="divide-y divide-neutral-100" data-testid="vl-history">
            {[...history].reverse().map((h) => (
                <li key={h.entry_id} data-testid={`vl-history-${h.entry_id}`}
                    className="flex items-start justify-between gap-3 py-2 text-sm">
                    <div>
                        <div className={h.state === "REVERSED" ? "text-neutral-400 line-through" : "text-neutral-800"}>
                            {vlEntryLabel(h)}
                        </div>
                        <div className="text-xs text-neutral-500">
                            <span data-testid={`vl-history-state-${h.entry_id}`}>{STATE_LABEL[h.state] || h.state}</span>
                            {" · "}{h.source === "CLOSE" ? i18n.t("common.close", "Close") : i18n.t("wf.vuosilomaHistory.manager", "Manager")}
                            {" · "}{formatYMDDate((h.created_at || "").slice(0, 10))}
                            {h.revision > 1 ? ` · revision ${h.revision}` : ""}
                            {h.reason && h.entry_type !== "CORRECTION" ? ` · ${h.reason}` : ""}
                        </div>
                    </div>
                    {canManage && h.correctable && (
                        <Button variant="ghost" size="sm" onClick={() => onCorrect(h)}
                            data-testid={`vl-history-correct-${h.entry_id}`}>{i18n.t("wf.vuosilomaHistory.correct", "Correct")}</Button>
                    )}
                </li>
            ))}
        </ul>
    );
}
